import { useQuery } from '@apollo/client'
import { sortBy } from 'lodash'

import {
  CommandModule,
  DEFAULT_SITE_INDUCTION_ACTIONS,
  DynamicActionsProps,
} from './config'

import { useLocale } from '@/context/localeContext'
import { useProject } from '@/context/projectContext'
import { TimezonedDate } from '@/context/timezoneContext'
import { GET_SITE_INDUCTIONS_FOR_SEARCH } from '@/modules/inductions/graphQL'
import { InductionTag } from '@/modules/inductions/InductionTag'
import { getWorkerName, routes } from '@/utils/index'

import {
  SiteInductionsForSearchUiQuery,
  SiteInductionsForSearchUiQueryVariables,
} from 'types/api.graphql'

export const DynamicSiteInductionActions: React.FC<DynamicActionsProps> = ({
  activePage,
  debouncedSearchText,
  replaceParentSubItems,
}) => {
  const { t } = useLocale()
  const { project, isProjectSelected } = useProject()

  useQuery<
    SiteInductionsForSearchUiQuery,
    SiteInductionsForSearchUiQueryVariables
  >(GET_SITE_INDUCTIONS_FOR_SEARCH, {
    variables: {
      projectId: isProjectSelected ? project?.id : undefined,
      filter: { searchString: debouncedSearchText },
      pagination: { limit: 10, offset: 0 },
    },
    skip:
      activePage !== CommandModule.SiteInductions ||
      !isProjectSelected ||
      !debouncedSearchText?.length,
    onCompleted: (data) => {
      replaceParentSubItems(CommandModule.SiteInductions, [
        ...DEFAULT_SITE_INDUCTION_ACTIONS,
        ...(sortBy(data?.projectInductions, 'createdAt')
          ?.reverse()
          ?.map((induction) => ({
            id: induction.id,
            name: t('induction:titles.workerInduction', {
              workerName: getWorkerName(induction.worker),
            }),
            description: <TimezonedDate date={induction.createdAt} />,
            extra: <InductionTag status={induction.status} />,
            href: routes.siteInductions.view(induction.id),
          })) ?? []),
      ])
    },
  })

  return null
}
